import React from 'react';
import { StyledTextField } from '../../styles/matieralui/Form'

export const FormInput = (props) => {
    return (<StyledTextField {...props} onChange={(e) => props.onChange(e.target.value)} variant="outlined" />);
}